import React, { useEffect, useState } from 'react';
import { gt, valid } from 'semver';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { doLogoutThunk } from '../actions/auth';
import { hideTermsOfUse, showTermsOfUse, updateTermsOfUseVersion } from '../actions/termsOfUse';
import { TERMS_OF_USE_VERSION } from '../globals/settings';

const TermsOfUseScreen = () => {
    const [didTermsVersionUpdate, setDidTermsVersionUpdate] = useState(false);
    const languageStrings = useSelector((state) => state.language.strings);
    const optional = useSelector((state) => state.termsOfUse.optional);
    const showing = useSelector((state) => state.termsOfUse.showing);
    const acceptedTermsVersion = useSelector((state) => state.termsOfUse.acceptedTermsVersion) || '0.0.0';
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const isFakeLoggedIn = useSelector((state) => state.auth.isFakeLoggedIn);
    const dispatch = useDispatch();

    // user must be logged in
    useEffect(() => {
        if (isLoggedIn || isFakeLoggedIn) {
            if(acceptedTermsVersion === '0.0.0'){
                dispatch(showTermsOfUse());
            }
            else if (!valid(acceptedTermsVersion) || (TERMS_OF_USE_VERSION !== acceptedTermsVersion && gt(TERMS_OF_USE_VERSION, acceptedTermsVersion))) {
                setDidTermsVersionUpdate(true);
                dispatch(showTermsOfUse());
            }
        }
    }, [isLoggedIn, isFakeLoggedIn, acceptedTermsVersion])

    const disclaimer = () => {
        if (optional) {
            return (
                <>
                    {languageStrings.TERMS_OF_USE_APP_DISCLAIMER_OPTIONAL_1}
                    <strong>{languageStrings.TERMS_OF_USE_APP_DISCLAIMER_OPTIONAL_2}</strong>
                </>
            );
        } else if (didTermsVersionUpdate) {
            return (
                <>
                    {languageStrings.TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_1}
                    <strong>{languageStrings.TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_2}</strong>
                    {languageStrings.TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_3}
                    <strong>{languageStrings.TERMS_OF_USE_APP_NAME}</strong>
                    {languageStrings.TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_4}
                </>
            )
        } else {
            return (
                <>
                    {languageStrings.TERMS_OF_USE_LOGIN_DISCLAIMER_1}
                    <strong>{languageStrings.TERMS_OF_USE_APP_NAME}</strong>
                    {languageStrings.TERMS_OF_USE_LOGIN_DISCLAIMER_2}
                </>
            );
        }
    }

    const hideModal = () => {
        dispatch(hideTermsOfUse());
    }

    const handleAccept = () => {
        if (!isFakeLoggedIn)
            dispatch(updateTermsOfUseVersion(TERMS_OF_USE_VERSION));
        hideModal();
    }

    const handleLogout = () => {
        if (!isFakeLoggedIn)
            dispatch(doLogoutThunk());
        hideModal();
    }

    return (
        <Modal centered size="lg" show={showing} onHide={hideModal} backdrop="static" keyboard={false}>
            <Modal.Header closeButton={optional}>
                <Modal.Title>
                    {languageStrings.TERMS_OF_USE_PAGE_NAME}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>
                    {disclaimer()}
                </h6>
                <ul className="p-3">
                    <li>{languageStrings.TERMS_OF_USE_ITEM_1}</li>
                    <li>{languageStrings.TERMS_OF_USE_ITEM_2}</li>
                    <li>{languageStrings.TERMS_OF_USE_ITEM_3}</li>
                    <li>{languageStrings.TERMS_OF_USE_ITEM_4}</li>
                    <li>{languageStrings.TERMS_OF_USE_ITEM_5}</li>
                    <li>
                        {languageStrings.TERMS_OF_USE_ITEM_6_1}
                        <strong>{languageStrings.TERMS_OF_USE_APP_NAME}</strong>
                        {languageStrings.TERMS_OF_USE_ITEM_6_2}
                    </li>
                    <li>
                        {languageStrings.TERMS_OF_USE_ITEM_7_1}
                        <strong>{languageStrings.TERMS_OF_USE_APP_NAME}</strong>
                        {languageStrings.TERMS_OF_USE_ITEM_7_2}
                    </li>
                    <li>
                        {languageStrings.TERMS_OF_USE_ITEM_8_1}
                        <strong>{languageStrings.TERMS_OF_USE_APP_NAME}</strong>
                        {languageStrings.TERMS_OF_USE_ITEM_8_2}
                    </li>
                    <li>
                        {languageStrings.TERMS_OF_USE_ITEM_9_1}
                        <strong>{languageStrings.TERMS_OF_USE_APP_NAME}</strong>
                        {languageStrings.TERMS_OF_USE_ITEM_9_2}
                    </li>
                    <li>
                        {languageStrings.TERMS_OF_USE_ITEM_10_1}
                        <strong>{languageStrings.TERMS_OF_USE_APP_NAME}</strong>
                        {languageStrings.TERMS_OF_USE_ITEM_10_2}
                    </li>
                    <li>
                        {languageStrings.TERMS_OF_USE_ITEM_11_1}
                        <strong>{languageStrings.TERMS_OF_USE_APP_NAME}</strong>
                        {languageStrings.TERMS_OF_USE_ITEM_11_2}
                    </li>
                </ul>
                {!optional &&
                    <div className="row justify-content-center">
                        <Button variant="primary" onClick={handleAccept} className="mr-3">{languageStrings.TERMS_OF_USE_ACCEPT_BUTTON}</Button>
                        {/* <Button variant="secondary" onClick={handleLogout}>{languageStrings.TERMS_OF_USE_CANCEL_BUTTON}</Button> */}
                    </div>
                }
            </Modal.Body>
        </Modal>
    );
}

export default withRouter(TermsOfUseScreen);
